import { Typography } from '../primitives/index.js'
import { capitalize, isDocumentEntity } from '@tunasong/models'
import type { Entity, Persisted } from '@tunasong/schemas'
import type { FC } from 'react'
import { useDeviceUISettings } from '../hooks/device-ui-settings.js'
import TagList from '../tags/tag-list.js'
import ContentViews from './content-views.js'
import { Divider } from './divider.js'
import { useContentViews } from '@tunasong/plugin-lib'
import cn from 'classnames'
import styles from './content-container-settings.module.css'
import { TheoryCuesSetting } from './theory-cues-setting.js'

export interface ContentContainerSettingsProps {
  className?: string
  entity: Persisted<Entity>

  EntityControls?: FC<{ entity?: Persisted<Entity>; onActive?: (active: boolean) => void }>
}

export const ContentContainerSettings: FC<ContentContainerSettingsProps> = props => {
  const { entity, EntityControls, className, ...restProps } = props

  const contentViews = useContentViews(entity)

  // Filter by tags
  const { tagsFilter, setTagsFilter } = useDeviceUISettings()

  return (
    // This is the scroll container for the contentEl
    <>
      <div className={cn(styles.root, className)} {...restProps}>
        {contentViews.length > 1 ? (
          <>
            <Typography variant="subtitle1" className={styles.subtitle}>
              Content view
            </Typography>
            <ContentViews entity={entity} />
          </>
        ) : null}

        <label htmlFor="tag-list" className={styles.subtitle}>
          <Typography variant="subtitle1" component="span">
            Show by tags
          </Typography>
        </label>
        <TagList placeholder="Add a tag and press Enter" tags={tagsFilter} onChange={setTagsFilter} size="small" />

        {/* Chords render only in documents (page, song), so only they get the level control. */}
        {isDocumentEntity(entity) ? <TheoryCuesSetting /> : null}

        {EntityControls ? (
          <>
            <Divider>{capitalize(entity.type)} settings</Divider>
            <EntityControls entity={entity} />
          </>
        ) : null}
      </div>
    </>
  )
}

export default ContentContainerSettings
